<template>
  <div>
    <el-table
      :data="emails"
      stripe
      size="mini"
      class="mb-3"
    >
      <el-table-column
        label="Additional Emails"
        :formatter="row => $_.get(row, 'email', '-')"
      />
      <el-table-column
        label="Actions"
        align="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            @click.native="removeEmail(scope.$index, scope.row)"
          >
            Remove
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-form
      ref="form"
      :inline="true"
      :model="form"
      size="small"
      :rules="rules"
    >
      <el-form-item
        label="Email Address"
        prop="email"
      >
        <el-input
          v-model="form.email"
          placeholder="Email Address"
          style="width: 300px;"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click.native="add"
        >
          Add
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    additionals: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      form: {},
      rules: {
        email: [
          { required: true, message: 'Please input email address', trigger: 'blur' },
          { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    emails () {
      return this.additionals.map(email => ({ email }))
    }
  },
  methods: {
    add () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.additionals.push(this.form.email)
          this.form.email = ''
        }
      })
    },
    removeEmail (index) {
      this.additionals.splice(index, 1)
    }
  }
}
</script>

<style>

</style>
